import { useGetContext } from "@onefront/forrestjs-react-root";
import { useQueryString } from "./use-query-string";

const getIsEmbed = (query, urlKey) => {
  // Use existing session setting
  if (query[urlKey] === undefined || query[urlKey] === "") {
    return false;
  }

  // Set the info to session storage for the lifetime of the setting.
  if (["false", "no", "0", "-1"].includes(query[urlKey])) {
    return false;
  } else {
    return true;
  }
};

export const useIsEmbed = () => {
  const urlKey = useGetContext("one.layout.embed.param.key");

  const qs = useQueryString();
  const queryString = qs.getAllItems();

  return {
    isEmbed: getIsEmbed(queryString, urlKey),
    urlKey
  };
};
